export default __webpack_public_path__ + "static/media/create-new-annotation.13ed6f4e.png";